define([
    'text!index2021-cooperate/component/item-gallery.html',
    'index2021-cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 5,
                    companyName: '',
                    projectName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    companyInfo: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/item-gallery.js
// module id = 239
// module chunks = 0